var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex item"},[_c('small',[_vm._v(_vm._s(_vm.count)+" "+_vm._s(_vm.transChoice(("community.profile." + _vm.label), _vm.count))+" ")]),_c('span',{staticClass:"separator pl-2 pr-2"},[_vm._v("|")])])}
var staticRenderFns = []

export { render, staticRenderFns }